import { useEffect, useState } from "react";

export function usePageTitle(title: string, description?: string) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    let metaEl: HTMLMetaElement | null = null;
    let prevDesc: string | null = null;
    if (description) {
      metaEl = document.querySelector('meta[name="description"]');
      if (metaEl) {
        prevDesc = metaEl.getAttribute("content");
        metaEl.setAttribute("content", description);
      }
    }
    return () => {
      document.title = prevTitle;
      if (metaEl && prevDesc !== null) metaEl.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}

/** 模拟数据请求，用于展示加载骨架屏 */
export function useSimulatedLoading(deps: unknown[], delay = 420): boolean {
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(deps);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), delay);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return loading;
}